import Header from '../components/header';

export default function DeepCode() {
  return <><Header /></>;
}
